import type { AxiosError } from 'axios';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createSkillsService,
  // deleteSkillsService,
  getSkillsService,
  updateSkillsService,
} from 'admin/services/skillsServices';
import toast from 'react-hot-toast';

interface ISkillPayload {
  name: string;
  isPublic?: boolean;
}

export const useSkills = () => {
  const queryClient = useQueryClient();

  const getSkills = useQuery({
    queryFn: getSkillsService,
    queryKey: ['get-skills'],
  });

  const createSkill = useMutation({
    mutationFn: (payload: ISkillPayload) => createSkillsService(payload),
    onError: (error: AxiosError) => {
      console.error('Create skill error:', error);
      toast.error('Skill Creation Failed');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['get-skills'] });
      toast.success('Skill Created Successfully');
    },
  });

  const updateSkill = useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: ISkillPayload }) =>
      updateSkillsService(id, payload),
    onError: (error: AxiosError) => {
      console.error('Update skill error:', error);
      toast.error('Skill Updation Failed');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['get-skills'] });
      toast.success('Skill Updated Successfully');
    },
  });

  // const deleteSkill = useMutation({
  //   mutationFn: (id: string) => deleteSkillsService(id),
  //   onSuccess: () => {
  //     queryClient.invalidateQueries({ queryKey: ['get-skills'] });
  //     toast.success('Skill Deleted Successfully');
  //   },
  //   onError: (error: any) => {
  //     console.error('Delete skill error:', error);
  //     toast.error('Skill Deletion Failed');
  //   },
  // });

  return {
    createSkill,
    getSkills,
    updateSkill,
    // deleteSkill,
  };
};
